import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
  type NavigationGuardNext,
  type RouteLocationNormalized,
} from 'vue-router';
import UnitList from './views/UnitList.vue';
import UnitDetail from './views/UnitDetail.vue';
import ConsumableDetail from './views/ConsumableDetail.vue';
import Login from './views/Login.vue';
import Terms from './views/Terms.vue';
import { isUserLoggedIn } from '@acs/components-library/src/auth.js';
import { isDemo } from '@acs/components-library/src/demo.js';
import { useFeatureFlagsStore } from '@acs/components-library/src/stores/featureFlagsStore';
import { useForceUpdateStore } from '@acs/components-library/src/stores/forceUpdateStore';

function requireAuth(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): void {
  if (isUserLoggedIn() || isDemo()) {
    return next();
  } else {
    return next({
      name: 'Login',
      query: { redirect: to.fullPath },
      replace: true,
    });
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/',
    name: 'UnitList',
    component: UnitList,
    beforeEnter: requireAuth,
  },
  {
    path: '/unit/:sn/:tab?',
    name: 'UnitDetail',
    component: UnitDetail,
    beforeEnter: requireAuth,
  },
  {
    path: '/unit/:sn/consumable/:consumable',
    name: 'ConsumableDetail',
    component: ConsumableDetail,
    beforeEnter: requireAuth,
  },
  {
    path: '/terms-and-conditions',
    name: 'Terms',
    component: Terms,
    beforeEnter: requireAuth,
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.afterEach(() => {
  useFeatureFlagsStore().touch();
  useForceUpdateStore().touch();
});

export default router;
